import {jwtServerInstance} from "../index";
import qs from	'qs'

export const getOrderTaskList = (queryform,pagination) =>{
    return jwtServerInstance.request({
        url:'/b2corder/queryorderlist',
        method:'post',
        data:qs.stringify({
            shopname: queryform.shopInfo,
            taskType: queryform.tasktype,
            taskId: queryform.taskId,
            orderNum: queryform.orderNum,
            plateordernum:queryform.plateordernum,
            customerId:queryform.customerId,
            plateformUsername:queryform.plateformUsername,
            reviewstatus:queryform.reviewstatus,
            status: queryform.status,
            startTime: queryform.timeRange?queryform.timeRange[0]:null,
            endTime: queryform.timeRange?queryform.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const getOrderExpressList = (queryform,pagination) =>{
    return jwtServerInstance.request({
        url:'/b2corder/qeruyexpresslist',
        method:'post',
        data:qs.stringify({
            shopname: queryform.shopInfo,
            taskType: queryform.taskType,
            taskNum: queryform.taskId,
            ordernum: queryform.ordernum,
            plateordernum:queryform.plateordernum,
            customerId:queryform.customerId,
            plateformUsername:queryform.plateformUsername,
            reviewstatus:queryform.reviewstatus,
            expressStatus:queryform.expressStatus,
            status: queryform.status,
            startTime: queryform.timeRange?queryform.timeRange[0]:null,
            endTime: queryform.timeRange?queryform.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export  const getOrderTaskDetail = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2corder/qeruyOrderDetail',
        method:'post',
        data: qs.stringify({
            orderId: queryForm.orderId,
            orderNum: queryForm.orderNum
        })
    });
}

export  const updateExpressInfo = (b2cOrder) => {
    return jwtServerInstance.request({
        url:'/b2corder/update',
        method:'post',
        data: b2cOrder
    });
}

export  const getReciveOrderAddress = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/queryorderaddr',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            plateUserName:data.plateUserName
        })
    });
}

export  const queryOrderLogDetail = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2ctaskorder/adminorderlog',
        method:'post',
        data: qs.stringify({
            orderId: queryForm.orderId,
            customerId: queryForm.customerId
        })
    });
}

export const updateOrderStatus = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/updatestatus',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            orderStatus: data.orderStatus,
            remarks: ""
        })
    });
}

//新增确认追评
export const confirmChaseStatus = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/chasestatus',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            orderStatus: data.orderStatus
        })
    });
}

//取消追评
export const rejectExtraReviewOperInfo =(data) =>{
    return jwtServerInstance.request({
        url: '/taskservice/rejectextrareview',
        method: 'post',
        data: qs.stringify({
            orderId: data.orderId
        })
    });
}


export const updateOrderMoney = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/updateodmoney',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            plateformNumbers: data.plateformNumbers,
            updateMoney:data.updateMoney,
            statusStr: data.statusStr,
            remarks: data.remarks
        })
    });
}

export const cancelOrder = (orderId) => {
    return jwtServerInstance.request({
        url:'/b2corder/cancelborder',
        method:'post',
        data: qs.stringify({
            orderId:orderId
        })
    });
}

export const cancelOrders = (orders) => {
    return jwtServerInstance.request({
        url:'/b2corder/cancelborders',
        method:'post',
        data: orders
    });
}

export const updateBatchOrderStatus = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/updatebatchstatus',
        method:'post',
        data: data
    });
}


export const getAdminOrderVoList = (queryform, pagination) =>{
    return jwtServerInstance.request({
        url:'/b2corder/queryadminorderlist',
        method:'post',
        data:qs.stringify({
            orderId: queryform.orderId,
            plateformOrderNumbers: queryform.plateformOrderNumbers,
            taskId: queryform.taskId,
            businessStoreName: queryform.businessStoreName,
            shopName:queryform.shopName,
            customerName:queryform.customerName,
            customerPlateformUserName:queryform.customerPlateformUserName,
            taskType:queryform.tasktypeId,
            status:queryform.status,
            moneyReturnStatus:queryform.moneyReturnStatus,
            orderTime:queryform.orderTime,
            startTime: queryform.timeRange?queryform.timeRange[0]:null,
            endTime: queryform.timeRange?queryform.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const addOrderRemarks = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/addremarks',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            remarks: data.remarks
        })
    });
}

export const getOrderMoneyInfo = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/queryordermoney',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId
        })
    });
}

export const changeMoneyLogs = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/changemoneyaccount',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            businessMoney:data.businessStoreMoney,
            customerMoney:data.customerMoney,
            status:data.orderStatus,
            remarks: data.orderRemarks
        })
    });
}

export const assignOrderToCustomer = (data) => {
    return jwtServerInstance.request({
        url:'/b2ctaskorder/assignorder',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            userName:data.userName
        })
    });
}

export const businessSelfReview = (data) => {
    return jwtServerInstance.request({
        url:'/b2ctaskorder/businessselfreview',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId,
            customerId:data.userId,
            breviewRes: data.reviewRes
        })
    });
}

export const businessBatchSelfReview = (data) => {
    return jwtServerInstance.request({
        url:'/b2ctaskorder/businessbatchselfreview',
        method:'post',
        data: data
    });
}

//新增催评接口
export const addPrompReview = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/requestprompstatus',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId
        })
    });
}

//批量添加催评
export const addBatchPrompReview = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/requestbatchprompstatus',
        method:'post',
        data: data
    });
}

//取消催评
export const cancelPrompReview = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/rebackprompstatus',
        method:'post',
        data: qs.stringify({
            orderId:data.orderId
        })
    });
}

//批量取消催评
export const cancelBatchPrompReview = (data) => {
    return jwtServerInstance.request({
        url:'/b2corder/rebackbatchprompstatus',
        method:'post',
        data: data
    });
}


//新增订单回池和回池取消
export const rebackPondOrCancelOrder = (orderId, cancelOrder) => {
    return jwtServerInstance.request({
        url:'/b2corder/rebackpondorcancel',
        method:'post',
        data: qs.stringify({
            orderId:orderId,
            cancelOrder: cancelOrder
        })
    });
}
